import React from 'react';
import { theme } from '../theme';

// ─── Spinner ─────────────────────────────────────────────
// Navy ring with one transparent quadrant, rotates via existing stx-spin keyframe.
// Use `label` for inline status; pass `block` for centered full-area placement.
export const Spinner: React.FC<{
  size?: number;
  label?: string;
  block?: boolean;
  color?: string;
}> = ({ size = 28, label, block, color = theme.colors.navy }) => {
  const ring = (
    <span
      aria-label="Lädt"
      style={{
        display: 'inline-block', width: size, height: size,
        borderRadius: '50%',
        border: `2px solid ${color}`,
        borderTopColor: 'transparent',
        animation: 'stx-spin 0.9s linear infinite',
        flexShrink: 0,
      }}
    />
  );
  if (!label && !block) return ring;
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing.sm,
      flexDirection: label ? 'column' : 'row',
      ...(block ? { padding: theme.spacing.lg, minHeight: 120 } : {}),
    }}>
      {ring}
      {label && (
        <span style={{
          fontSize: 13, color: theme.colors.navyMid, fontFamily: theme.font.family,
          fontWeight: 500, letterSpacing: 0.2,
        }}>{label}</span>
      )}
    </div>
  );
};
